import React from 'react'
import PrecedentResultsItem from 'components/search/results-item/PrecedentsResultsItem'
import LegislationResultsItemSectionContainer from 'redux/containers/components/search/results-item/LegislationResultsItemSectionContainer'
import QaResultsItem from 'components/search/results-item/QaResultsItem'
import CaResultsItemSectionContainer from 'redux/containers/components/search/results-item/CaResultsItemSectionContainer'

const views = {
  legislation: LegislationResultsItemSectionContainer,
  qa: QaResultsItem,
  precedents: PrecedentResultsItem,
  ca: CaResultsItemSectionContainer
}

const ResultsSection = ({ results, truncated, searchType }) => {
  const Component = views[searchType] || views.qa

  return !results
    ? null
    : (
      <section>
        <ul className='flex flex-column list-reset list-item-reset pl0 results-wrapper'>
          {results.map(q => (
            <Component key={q.tocId || q.id} {...{ ...q, truncated }} />
          ))}
        </ul>
      </section>
      )
}

export default ResultsSection
